import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../api/api-clientInformation';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-dialog',
  standalone: false,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent{
  apiClient = inject(Client);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly toastrService = inject(ToastrService);
  private readonly translate = inject(TranslateService);
  selectedFile?: File;
  actionName = '';
  message = '';
  readonly maxCommentLength = 2000;
  readonly allowAttachment: boolean = false;
  descriptionFormControl = new FormControl('');

  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.actionName = data.actionName;
    this.message = data.message;
    this.allowAttachment = !!data.allowAttachment;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const maxSizeInMB = 50;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      this.toastrService.error(this.translate.instant('MESSAGES.ERROR.FILE_SIZE_EXCEEDS', { maxSize: maxSizeInMB }));
      input.value = '';
      return;
    }

    this.selectedFile = file;
    input.value = '';
    this.cdr.markForCheck();
  }

  onRemoveFile(): void {
    this.selectedFile = undefined;
    this.cdr.markForCheck();
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      comment: this.descriptionFormControl.value ?? '',
      file: this.selectedFile,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
